import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/auth.service';
import { AuthLead, AuthShell, AuthTitle, BackToLogin, DangerCallout, Field, FootNote, GhostButton, MintCallout, PrimaryButton, TextLink, emailError } from './AuthShell';

export function ForgotPasswordView() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [fieldError, setFieldError] = useState<string | null>(null);
    const [serverError, setServerError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const goLogin = () => navigate('/login');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const em = emailError(email);
        setFieldError(em);
        if (em) return;
        setIsLoading(true);
        setServerError(null);
        try {
            await authService.forgotPassword(email.trim());
            setSent(true);
        } catch (err: any) {
            setServerError(err.response?.data?.message || 'Failed to send reset email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (sent) {
        return (
            <AuthShell>
                <BackToLogin onClick={goLogin} />
                <AuthTitle lead="Check your" accent="inbox" marginTop={10} />
                <MintCallout>
                    If an account exists for <span style={{ fontWeight: 700 }}>{email.trim() || 'that address'}</span>, a link to reset your password is on its way.
                </MintCallout>
                <GhostButton onClick={() => setSent(false)}>Try another email</GhostButton>
                <FootNote marginTop={20}>
                    Remembered it? <TextLink to="/login" onClick={goLogin}>Log in</TextLink>
                </FootNote>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <BackToLogin onClick={goLogin} />
            <AuthTitle lead="Reset your" accent="password" marginTop={10} />
            <AuthLead>Give us the email on your account and we'll send a link to set a new password.</AuthLead>

            <form onSubmit={handleSubmit} noValidate>
                <div style={{ marginTop: 24 }}>
                    <Field label="Email" type="email" name="email" autoComplete="email" autoFocus value={email} onChange={(v) => { setEmail(v); setFieldError(null); }} placeholder="you@usaha.id" error={fieldError} />
                </div>
                {serverError && <DangerCallout>{serverError}</DangerCallout>}
                <PrimaryButton disabled={isLoading}>{isLoading ? 'Sending link…' : 'Send reset link'}</PrimaryButton>
            </form>

            <FootNote marginTop={20}>
                Remembered it? <TextLink to="/login" onClick={goLogin}>Log in</TextLink>
            </FootNote>
        </AuthShell>
    );
}
